import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  getAllEventDefinations,
  getEventDefinationsCount,
  putEventDefinationData,
} from "api/EventTriggerApi";
import Table from "../Table";
import ContantLoader from "views/ContantLoader";
import { useSelector, useDispatch } from "react-redux";
import { setEventSignalLoading } from "ReduxStore/Slices/eventandsignalSlice";

const AllEvents = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const dispatch = useDispatch();
  const { eventandsignalLoading } = useSelector(
    (state) => state.eventandsignalSetter
  );
  const searchText = useRef("");
  useEffect(() => {
    dispatch(setEventSignalLoading(true));
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setEventSignalLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);

    searchText.current.value !== ""
      ? await getEventDefinationsCount(searchText.current.value)
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
          setTotal(data.count);
        })
      : await getEventDefinationsCount()
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
          setTotal(data.count);
        })

    searchText.current.value !== ""
      ? await getAllEventDefinations(
        pageSize,
        startRow,
        searchText.current.value
      )
        .then((data) => {
          setDataApi(data);
          dispatch(setEventSignalLoading(false));
        })
      : await getAllEventDefinations(pageSize, startRow)
        .then((data) => {
          setDataApi(data);
          dispatch(setEventSignalLoading(false));
        })
  }, []);

  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Date",
        accessor: "createdAt",
      },
      {
        // width: 300,
        Header: "Actions",
        accessor: "",
        Cell: ({ cell }) => (

          (
            <div className="events_actions">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Preview Event
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-eye"
                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={() => previewEvent(cell.row.original.id)}
                ></i>
              </OverlayTrigger>
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    List Events
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-file-alt"
                  style={{ color: "gray", fontSize: "20px" }}
                  onClick={() => listEvent(cell.row.original.id)}
                ></i>
              </OverlayTrigger>
            </div>
          )
        ),
      },
      {
        // width: 300,
        Header: "Status",
        accessor: "",
        Cell: ({ cell }) => (
          // 
          <div className="custom-control custom-switch d-flex justify-content-center">
            <input
              type="checkbox"
              className="custom-control-input"
              id={"customSwitch1" + cell.row.original.id}
              onClick={(e) => {
                let isActive;
                e.preventDefault();
                e.stopPropagation();
                activate(
                  cell.row.original.id,
                  cell.row.original.isActive ? false : true
                );

                !cell.row.original.isActive
                  ? (isActive = true)
                  : (isActive = false);

                let temp = [...dataApi];
                temp[cell.row.index].isActive = isActive;
                setDataApi(temp);
              }}
              checked={cell.row.original.isActive ? true : false}
            ></input>
            <label
              className="custom-control-label"
              for={"customSwitch1" + cell.row.original.id}
            ></label>
          </div>
        ),
      },
    ],
    [dataApi]
  );

  const activate = (id, is) => {
    var data = {
      isActive: is,
    };
    putEventDefinationData(id, data);
  };
  const previewEvent = (id) => {
    props.history.push(`/admin/triggersAndEvents/createEvent?event=${id}`);
  };
  const listEvent = (id) => {
    props.history.push(`/admin/triggersAndEvents/listEvent?event=${id}`);
  };

  return (
    <Container>
            <div className="d-flex align-items-center pr-4 " style={{justifyContent:"space-between"}} > 

      <div className="page_heading">

        <h2>Events List</h2>

        <p className="sm d-flex align-items-center">You have {total} Events.</p>
      </div>
      <div className="search_bar_wrap d-flex">
            {/* <label className="search_label mr-3">Search</label> */}
            <input
              className="form-control search-input"
              id="search_input"
              placeholder="Enter Name or Description "
              ref={searchText}
              style={{ maxWidth: "23%", marginLeft: "25px" }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  dispatch(setEventSignalLoading(true));
                  fetchData({
                    pageSize: 10,
                    pageIndex: 0,
                    searchText: searchText.current.value,
                  }).then(() => {
                    dispatch(setEventSignalLoading(false));
                  });
                }
              }}
            />
            <button
              onClick={() => {
                dispatch(setEventSignalLoading(true));
                fetchData({
                  pageSize: 10,
                  pageIndex: 0,
                  searchText: searchText.current.value,
                }).then(() => {
                  dispatch(setEventSignalLoading(false));
                });
              }}
              className="lg_btn tertiary search_btn"
              style={{ height: "38px", margin: "0 0 1vh 1vh" }}
            >
              {eventandsignalLoading ? "Loading..." : "Search"}
            </button>
          </div>
      </div>
      <div></div>
      {dataApi ? (
        <div className="dataTableOuter">
     
          <div className="table-flter rdt_Pagination d-flex align-items-center">
            <span className="inline-label ml-auto">
              Page No. {pageIndex + 1} of {pageCount}
            </span>
          </div>
          {
            <Table
              columns={columns}
              data={data}
              pageCount={pageCount}
              fetchData={fetchData}
              loading={eventandsignalLoading}
            ></Table>
          }
        </div>
      ) : (
        <ContactLoader />
      )}
    </Container>
  );
};

export default AllEvents;
